import { ContentStatus } from '../model';

export const formatTableDateTime = (value: string | null | undefined) => {
  if (!value) return '—';

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;

  return date.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatStatus = (status: ContentStatus) => {
  if (status === 'draft') return 'Черновик';
  return 'Опубликовано';
};

export const isCourseArchived = (course: { deletedAt?: string | null }) => Boolean(course.deletedAt);
